export default __webpack_public_path__ + "static/media/tokenlist.831c6277.svg";